import { SonoraEntityType, SonoraTopicEntity } from 'owa-editor-sonora-types';
import { trace } from 'owa-trace';
import { Suggestion } from 'owa-userdataservice';

export default function parseVivaTopicCardSuggestions(
    suggestion: Suggestion
): SonoraTopicEntity[] | undefined {
    try {
        const data = JSON.parse(suggestion.encodedJsonData);
        if (data?.Value) {
            const suggestions = data.Value.map(userDataInfo => {
                return <SonoraTopicEntity>{
                    type: SonoraEntityType.VivaTopicEntity,
                    id: userDataInfo.Id,
                    relevanceScore: userDataInfo.RelevanceScore,
                    definition: userDataInfo.Definition,
                    displayName: userDataInfo.DisplayName,
                    url: userDataInfo.Url,
                    lastModifiedTime: userDataInfo.LastModifiedTime,
                    entityDetails: userDataInfo,
                };
            });

            return suggestions;
        }
    } catch (error) {
        trace.warn(`[HoneybeeSonora|parseVivaTopicEntitySuggestions] Error: ${error}`);
    }
    return undefined;
}
